module.exports = __webpack_public_path__ + "static/media/mms-capabality.5ef4f323.png";